import { render, staticRenderFns } from "./Detail-Part.vue?vue&type=template&id=d0981890"
import script from "./Detail-Part.vue?vue&type=script&lang=js"
export * from "./Detail-Part.vue?vue&type=script&lang=js"
import style0 from "./Detail-Part.vue?vue&type=style&index=0&id=d0981890&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports